import { Injectable } from '@angular/core';
import { Component, } from '@angular/core'

@Component({
  selector: 'app-updateServicePopUp',
  templateUrl: 'updateServicePopUp.html',
})
export class updateServicePopUp {}
